module.exports = __webpack_public_path__ + "img/xhs-code.a796d897.png";